module.exports = __webpack_public_path__ + "img/ES.8fad7fca.jpg";